import { render, staticRenderFns } from "./createStaffServicesModal.vue?vue&type=template&id=64809a04&"
import script from "./createStaffServicesModal.vue?vue&type=script&lang=js&"
export * from "./createStaffServicesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64809a04')) {
      api.createRecord('64809a04', component.options)
    } else {
      api.reload('64809a04', component.options)
    }
    module.hot.accept("./createStaffServicesModal.vue?vue&type=template&id=64809a04&", function () {
      api.rerender('64809a04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/branches/components/createStaffServicesModal.vue"
export default component.exports